import { logger } from "../../util";
import BossClient from './boss-client';
import BossGroupClient from './boss-group-client';
import BossReporter from './boss-reporter';
function createReportClient(config) {
    const isArrayConfig = Array.isArray(config);
    if (isArrayConfig && config.length > 1) {
        return new BossGroupClient(config);
    }
    return new BossClient(isArrayConfig ? config[0] : config);
}
/**
 * @description 创建BossReporter中间件
 * @deprecated Boss接口即将下线，建议尽快切换至atta，并使用createAttaReporter创建实例
 * @param { IBossReportOptions } options 配置对象
 * @returns { BossReporter }
 * @example
 * ```ts
 * import reportPlugin, { createBossReporter } from '@tencent/vft-report';
 * // 单boss上报
 * Vue.use(reportPlugin, {
 *   middlewares: [
 *     createBossReporter({
 *       config: { bossId: '123456', pwd: 'xxx' },
 *     }),
 *   ],
 * });
 *
 * // 多boss上报
 * Vue.use(reportPlugin, {
 *   middlewares: [
 *     createBossReporter({
 *       config: [
 *         { bossId: '123456', pwd: 'xxx' },
 *         { bossId: '654321', pwd: 'xxx' }
 *       ],
 *     }),
 *   ],
 * });
 * ```
 */
export function createBossReporter(options) {
    logger.warn('[deprecated]Boss接口即将下线，建议尽快切换至atta，并使用createAttaReporter创建实例');
    return createReporter(options);
}
;
/**
 * @description 为了兼容原有直接new BossReporter的调用方式，需要传入options.config
 * @deprecated 建议使用createBossReporter来创建实例
 */
export default class BossReport extends BossReporter {
    constructor(options) {
        logger.warn('[Deprecated]use createBossReporter instead');
        const { config } = options;
        if (!config || (Array.isArray(config) && config.length === 0)) {
            throw new Error('[boss-report.BossReport]缺少config配置');
        }
        super(options, createReportClient(options.config));
    }
}
/**
 * 创建AttaReporter实例
 * @param { IAttaReportOptions } options atta配置
 * @returns { BossReporter }
 */
export function createAttaReporter(options) {
    return createReporter(options);
}
function createReporter(options) {
    const { config } = options;
    if (!config || (Array.isArray(config) && config.length === 0)) {
        throw new Error('[boss-report.createReporter]缺少config配置');
    }
    return new BossReporter(options, createReportClient(config));
}
